// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__yRZzp","name":"Header_name__1yMMp","birthday":"Header_birthday__35uRt","skeleton":"Header_skeleton__1iZDf"};